import { render } from "./AccountQuestionOutline.vue?vue&type=template&id=06f869e4"
import script from "./AccountQuestionOutline.vue?vue&type=script&lang=js"
export * from "./AccountQuestionOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__